import { useMemo } from 'react';

import { mediaManagerRelatedImagesClickSrc26Evid612 } from '@wix/bi-logger-media-data/v2';
import { mediaManagerRelatedImagesClickSrc26Evid612Params } from '@wix/bi-logger-media-data/v2/types';

import { bi } from '../../../services/loggers/bi';
import { MediaManagerSDKFile } from '../../media-manager-sdk';
import { extractCommonBiFieldsFromItems } from '../../bi';
import { useFileType } from './useFileType';
import { MainSource } from '../../../constants/Source';
import { useSearchResultsBI } from '../../../containers/FilesManager/SearchResults/useSearchResultsBI';
import { IFilterItem } from '../../../containers/FilesManager/ExtendedItemsFilters/ExtendedItemsFilters.types';

export const RelatedItemsClickOrigin = {
  Icon: 'icon',
};

type OpenRelatedItemsOptions = { success: boolean; tabName: MainSource; category?: IFilterItem; searchTerm: string };

export const useRelatedItemsAnalytics = () => {
  const fileType = useFileType();
  const { searchId } = useSearchResultsBI();

  return useMemo(
    () => ({
      trackOpenRelatedItems: (
        item: MediaManagerSDKFile,
        { success, tabName, category, searchTerm }: OpenRelatedItemsOptions,
      ) => {
        const commonFields = extractCommonBiFieldsFromItems(item, { fileType });

        const params: mediaManagerRelatedImagesClickSrc26Evid612Params = {
          clickOrigin: RelatedItemsClickOrigin.Icon,
          name: item.name,
          success,
          fileId: item.id,
          fileType: commonFields.fileType,
          fileUrl: item.fileUrl,
          tabName,
          category: category?.name,
          categoryId: category?.id,
          search_id: searchId,
          searchTerm,
        };

        bi.logger().report(mediaManagerRelatedImagesClickSrc26Evid612(params));
      },
    }),
    [fileType, searchId],
  );
};
